export const handleInstructionsModal = (setInstructionsModal, instructionsModal) => {
    setInstructionsModal(!instructionsModal);
}